import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';
import { GamificationRequestHandler } from './gamification-request.handler';

@Component({
  selector: 'sym-gamification-request',
  templateUrl: './gamification-request.component.html',
  styleUrls: ['./gamification-request.component.scss'],
})
export class GamificationRequestComponent extends GamificationRequestHandler {
  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }
}
